import React from "react";
import { SidebarComponent } from "@syncfusion/ej2-react-navigations";
import { flyoutContainerRegistry } from "./FlyoutContainerRegistry";
import { useFlyoutContainer } from "./useFlyoutContainer";
import { SecondaryButton } from "../Buttons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export type FlyoutContainerProps = {
  userSettings?: Partial<React.ComponentProps<typeof SidebarComponent>>;
};

const FlyoutContainer: React.FC<FlyoutContainerProps> = ({ userSettings }) => {
  const { flyout, closeFlyout } = useFlyoutContainer();

  if (!flyout) {
    return null;
  }

  const { key, flyoutParams } = flyout;

  const entry = flyoutContainerRegistry.getFlyouts()[key];

  const {
    component: FlyoutComponent,
    sidebarSettings = {},
    defaultProps = {},
  } = entry;

  if (!FlyoutComponent) {
    return null;
  }

  // Merge default props with flyout params, with flyout params taking precedence
  const mergedProps = { ...defaultProps, ...(flyoutParams || {}) };

  return (
    <SidebarComponent
      className="flyout-drawer flyout-drawer-direct"
      isOpen={true}
      close={closeFlyout}
      width="50%"
      showBackdrop={true}
      position="Right"
      closeOnDocumentClick={false}
      {...userSettings}
      {...sidebarSettings}
    >
      <div className="flyout-close-button-wrapper">
        <SecondaryButton
          className="flyout-close-btn"
          iconProps={{
            icon: faTimes,
          }}
          minimal={true}
          onClick={closeFlyout}
        />
      </div>
      <div className="flyout-drawer-content">
        <div className="ucl-flyout-header-block"></div>
        <FlyoutComponent onExit={closeFlyout} {...mergedProps} />
        <div className="ucl-flyout-footer-block"></div>
      </div>
    </SidebarComponent>
  );
};

export default FlyoutContainer;
